<template>
  <div>
    <v-navigation-drawer
      :value="value"
      @input="$emit('input', $event)"
      fixed
      temporary
      width="280"
      app
      class="site-client-menu-drawer"
    >
      <v-list nav dense class="pt-2">
        <v-subheader class="menu-section-subheader">
          Esta tienda
        </v-subheader>
        <v-list-item @click="onInicio">
          <v-list-item-icon>
            <v-icon color="primary">mdi-home</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Inicio</v-list-item-title>
            <v-list-item-subtitle class="text-wrap">
              Catálogo de esta sucursal
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="onInformacion">
          <v-list-item-icon>
            <v-icon color="primary">mdi-information</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Información</v-list-item-title>
            <v-list-item-subtitle class="text-wrap">
              Horarios y contacto del local
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="onUbicacion">
          <v-list-item-icon>
            <v-icon color="primary">mdi-map-marker</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Ubicación</v-list-item-title>
            <v-list-item-subtitle class="text-wrap">
              Dónde está este local
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-divider class="my-2" />

        <v-subheader class="menu-section-subheader">
          Tu cuenta
        </v-subheader>
        <v-list-item @click="onCuenta">
          <v-list-item-icon>
            <v-icon color="primary">mdi-account-circle</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ isLoggedIn ? 'Mi cuenta' : 'Iniciar sesión' }}</v-list-item-title>
            <v-list-item-subtitle class="text-wrap">
              {{ isLoggedIn ? 'Tus datos y direcciones (en todas las tiendas)' : 'Accedé con Google para guardar tu perfil' }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="isLoggedIn && client" @click="onMisPedidos">
          <v-list-item-icon>
            <v-icon color="primary">mdi-history</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Mis pedidos</v-list-item-title>
            <v-list-item-subtitle class="text-wrap">
              Historial y repetir pedido
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-dialog v-model="dialogInfo" max-width="420" scrollable @click:outside="dialogInfo = false">
      <v-card>
        <v-btn icon absolute right top class="mt-1" aria-label="Cerrar" @click="dialogInfo = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-card-text class="text-center pt-8 pb-4">
          <v-icon color="primary" size="48">mdi-information</v-icon>
          <h2 class="text-h5 font-weight-bold mt-3 primary--text text--darken-2">Información</h2>
          <div v-if="data && data.Telefono" class="mt-4">
            <v-btn color="success" outlined small class="mb-2" :href="whatsappHref" target="_blank" rel="noopener">
              <v-icon left small>mdi-whatsapp</v-icon>
              WhatsApp
            </v-btn>
            <div class="text-body-2">{{ whatsappDisplay }}</div>
          </div>
          <p v-else class="text-body-2 grey--text mt-4">Teléfono no disponible.</p>
          <v-divider class="my-4" />
          <div v-if="horarioLineas.length" class="text-body-2">
            <div v-for="(line, idx) in horarioLineas" :key="idx" class="mb-2">
              <strong>{{ line.dia }}</strong>
              <div class="grey--text text--darken-1">{{ line.texto }}</div>
            </div>
          </div>
          <p v-else class="text-body-2 grey--text">Horario no publicado.</p>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogUbicacion" max-width="480" scrollable @click:outside="dialogUbicacion = false">
      <v-card>
        <v-btn icon absolute right top class="mt-1" aria-label="Cerrar" @click="dialogUbicacion = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-card-text class="text-center pt-8 pb-4">
          <v-icon color="primary" size="48">mdi-map-marker</v-icon>
          <h2 class="text-h5 font-weight-bold mt-3 primary--text text--darken-2">Ubicación</h2>
          <p v-if="direccionTexto" class="text-body-1 grey--text text--darken-1 mt-2">{{ direccionTexto }}</p>
          <p v-else class="text-body-2 grey--text mt-2">Dirección no disponible.</p>
          <div v-if="mapaValido" class="mt-4 rounded overflow-hidden" style="border-radius: 8px;">
            <GmapMap
              :center="mapCenter"
              :zoom="16"
              :options="{ streetViewControl: false, fullscreenControl: false }"
              style="width: 100%; height: 220px;"
            >
              <GmapMarker :position="mapCenter" />
            </GmapMap>
          </div>
          <div v-if="googleMapsHref !== '#'" class="mt-4">
            <v-btn text color="primary" small :href="googleMapsHref" target="_blank" rel="noopener">
              <v-icon small left>mdi-open-in-new</v-icon>
              Abrir en Google Maps
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'

const DIAS_ORDEN = [
  { key: 'lunes', label: 'Lunes' },
  { key: 'martes', label: 'Martes' },
  { key: 'miercoles', label: 'Miércoles' },
  { key: 'jueves', label: 'Jueves' },
  { key: 'viernes', label: 'Viernes' },
  { key: 'sabado', label: 'Sábado' },
  { key: 'domingo', label: 'Domingo' }
]

export default {
  name: 'SiteClientMenu',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dialogInfo: false,
      dialogUbicacion: false
    }
  },
  computed: {
    ...mapState('App', ['data']),
    ...mapState('Cuenta', ['firebaseUser']),
    isLoggedIn () {
      return !!this.firebaseUser
    },
    client () {
      return this.$route.params.client
    },
    direccionTexto () {
      return (this.data && this.data.Direccion) ? String(this.data.Direccion).trim() : ''
    },
    mapCenter () {
      if (!this.data) return { lat: -31.4, lng: -64.2 }
      const lat = Number(this.data.Lat)
      const lng = Number(this.data.Long)
      return { lat, lng }
    },
    mapaValido () {
      if (!this.data || this.data.Lat == null || this.data.Long == null) return false
      const lat = Number(this.data.Lat)
      const lng = Number(this.data.Long)
      return !Number.isNaN(lat) && !Number.isNaN(lng) && lat !== 0 && lng !== 0
    },
    googleMapsHref () {
      if (this.mapaValido) {
        const { lat, lng } = this.mapCenter
        return `https://www.google.com/maps?q=${lat},${lng}`
      }
      if (this.direccionTexto) {
        return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(this.direccionTexto)}`
      }
      return '#'
    },
    whatsappHref () {
      if (!this.data || !this.data.Telefono) return '#'
      return `https://api.whatsapp.com/send?phone=+549${this.data.Telefono}&text=${encodeURIComponent('Hola! Quisiera realizar una consulta')}`
    },
    whatsappDisplay () {
      if (!this.data || !this.data.Telefono) return ''
      return `+549 ${this.data.Telefono}`
    },
    horarioLineas () {
      const hr = this.data && this.data.horarioRegular
      if (!hr) return []
      if (hr.diasSemana) {
        const out = []
        for (const { key, label } of DIAS_ORDEN) {
          const groups = hr.diasSemana[key]
          if (!groups || !Array.isArray(groups) || groups.length === 0) continue
          const partes = []
          for (const group of groups) {
            if (!Array.isArray(group)) continue
            for (const s of group) {
              if (s && s.HsDesde != null && s.HsHasta != null) {
                partes.push(`${s.HsDesde} a ${s.HsHasta}`)
              }
            }
          }
          if (partes.length) out.push({ dia: label, texto: partes.join(' · ') })
        }
        if (out.length) return out
      }
      if (hr.dataOriginal && Array.isArray(hr.dataOriginal)) {
        return this.horarioDesdeDataOriginal(hr.dataOriginal)
      }
      return []
    }
  },
  methods: {
    horarioDesdeDataOriginal (dataOriginal) {
      const nombres = ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo']
      const porDia = {}
      for (let id = 1; id <= 7; id++) porDia[id] = []
      for (const grupo of dataOriginal) {
        if (!Array.isArray(grupo)) continue
        for (const s of grupo) {
          if (s && s.Id >= 1 && s.Id <= 7 && s.HsDesde != null && s.HsHasta != null) {
            porDia[s.Id].push(`${s.HsDesde} a ${s.HsHasta}`)
          }
        }
      }
      const out = []
      for (let id = 1; id <= 7; id++) {
        if (porDia[id].length) {
          out.push({ dia: nombres[id - 1], texto: [...new Set(porDia[id])].join(' · ') })
        }
      }
      return out
    },
    closeDrawer () {
      this.$emit('input', false)
    },
    onInicio () {
      this.closeDrawer()
      const client = this.client
      if (!client) return
      const mesaId = this.$route.params.mesaId
      if (mesaId) {
        if (
          this.$route.name === 'MesaQR' &&
          this.$route.params.client === client &&
          String(this.$route.params.mesaId) === String(mesaId)
        ) {
          return
        }
        this.$router.push({
          name: 'MesaQR',
          params: { client, mesaId }
        }).catch(() => {})
        return
      }
      if (this.$route.name === 'HomeShort') {
        if (this.$route.params.client === client) return
        this.$router.push({ name: 'HomeShort', params: { client } }).catch(() => {})
      } else {
        if (this.$route.name === 'Home' && this.$route.params.client === client) return
        this.$router.push({ name: 'Home', params: { client } }).catch(() => {})
      }
    },
    onInformacion () {
      this.closeDrawer()
      this.dialogInfo = true
    },
    onUbicacion () {
      this.closeDrawer()
      this.dialogUbicacion = true
    },
    onCuenta () {
      this.closeDrawer()
      if (this.$route.name === 'CuentaGlobal') return
      const client = this.client
      const mesaId = this.$route.params.mesaId
      const query = client
        ? {
            from: 'store',
            client,
            home: this.$route.name === 'HomeShort' ? 'HomeShort' : 'Home',
            ...(mesaId ? { mesaId: String(mesaId) } : {})
          }
        : { from: 'tiendas' }
      this.$router.push({ name: 'CuentaGlobal', query }).catch(() => {})
    },
    onMisPedidos () {
      this.closeDrawer()
      const client = this.client
      if (!client) return
      this.$router.push({ name: 'MisPedidos', params: { client } }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.menu-section-subheader {
  height: auto;
  line-height: 1.2;
  padding: 12px 16px 4px;
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 0.06em;
  color: rgba(0, 0, 0, 0.45) !important;
}
</style>
<style>
/* Por encima de chips (4), footer carrito (100); por debajo de v-dialog típico (~200) */
.site-client-menu-drawer.v-navigation-drawer--fixed {
  z-index: 150 !important;
}
</style>
